// 다이나믹 코드 유형
export const DYNAMIC_TYPE_CODE = {
  APPLY: 500001, // 채용 지원 유형 코드
  NEWS: 500002, // PR 뉴스 카테고리 코드
  LANG: 500003, // 언어 코드
  NOTICE: 500004, // PR 공지 카테고리 코드
  SCREEN: 500005, // 화면 유형 코드
} as const;

// 로컬 스토리지에 저장되는 키
export const LOCAL_STORAGE_KEY = {
  REMEMBER_ME: 'remember-me',
  COPIED_CONTENTS: 'copied-contents',
} as const;

// 상수 정의
export const DEFAULT_PREVIEW = '/images/placeholder.png';
